import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Shield, CheckCircle2, Users } from 'lucide-react';
const FeaturesSection = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      icon: Shield,
      title: "Descubra todas as nossas pol\xEDticas",
      description: "e fique por dentro do universo Pierre"
    }, {
      icon: CheckCircle2,
      title: "Clique na cl\xE1usula desejada e tenha",
      description: "acesso ao conte\xFAdo detalhado"
    }, {
      icon: Users,
      title: "Em caso de d\xFAvidas, converse com",
      description: "atendentes virtuais ou humanos"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const features = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="w-full mt-14 py-8 px-4"><div className="max-w-7xl mx-auto"><div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-12">{features.map(_temp)}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default FeaturesSection;
function _temp(feature, index) {
  const Icon = feature.icon;
  return <div key={index} className="flex items-center gap-3 flex-1 group"><div className="shrink-0 mt-0.5"><div className="size-14 rounded-full bg-gray-900 flex items-center justify-center transition-all"><Icon className="size-6 text-primary" strokeWidth={2} /></div></div><div className="flex-1"><p className="text-primary text-md leading-relaxed"><span className="font-semibold">{feature.title}</span>{" "}<span className=" text-muted-foreground">{feature.description}</span></p></div></div>;
}